import { AuthUserType, DataFileExplorerType } from "../../../Actions/Types"
import { Reducer } from "redux"
import { AuthAction } from "../../Auth"

export interface DataFileExplorerState {
    [index: string]: any[] | undefined
}

export interface DataFileExplorerAction {
    type: DataFileExplorerType | null
    payload?: {
        id: string
        data?: any[]
    }
}

const initialState: DataFileExplorerState = {}

export const DataFileExplorerReducer: Reducer<
    DataFileExplorerState,
    DataFileExplorerAction | AuthAction
> = (state = initialState, action): DataFileExplorerState => {
    switch (action.type) {
        case DataFileExplorerType.addData:
            const p = action.payload ? action.payload : null
            if (p === null) return state
            if (!p.data) return state
            const oldData = state[p.id] || []
            const newData = oldData.concat(p.data)
            return {
                ...state,
                [p.id]: newData
            }
        case DataFileExplorerType.clearData:
            return action.payload
                ? {
                      ...state,
                      [action.payload.id]: undefined
                  }
                : state
        case AuthUserType.signedOut:
            return initialState
        default:
            return state
    }
}
